import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';


@Component({
  selector: 'app-dynamic-translation-dialog',
  templateUrl: './dynamic-translation-dialog.component.html',
  styleUrls: ['./dynamic-translation-dialog.component.css']
})



export class DynamicTranslationDialogComponent implements OnInit {


  public subject$ = new Subject<ChangedTranslationValue[]>()
  public key: string
  public languages: Map<string, Entry>
  public isMultiLine: boolean = false
  public maxlength: number = 150
  public fieldName: string;

  data: Map<string, Entry>
  languageEntries:[string,any][];
  translationKeys: typeof TranslationKeys = TranslationKeys;


  constructor(private modalRef: BsModalRef) { }

  ngOnInit() {
    this.data = new Map<string, Entry>();
    this.languageEntries = Object.entries(this.languages);

    for (const [languageKey, value] of this.languageEntries) {
      this.data.set(languageKey, new Entry(value))
    }
  }

  confirm() {
    const dataEntries = Array.from(this.data.entries())

    var currentUrl = window.location.href;
    if (!currentUrl.includes('/configure/sub-category')) {
      const english = dataEntries.find(e => e[0] === 'en')
      if (!english[1].currentValue) {
        for (const [langKey, value] of dataEntries) {
          if (langKey !== 'en' && value.currentValue !== '') {
            english[1].currentValue = value.currentValue;
            break;
          }
        }
      }
    }

    this.setGermanicLanguages(dataEntries);

    const changedValues = dataEntries
      .filter(e => e[1].changed() || e[0] == 'en')
      .map(e => ({ language: e[0], value: e[1].currentValue }))

    this.subject$.next(changedValues);
    this.subject$.complete();
    this.modalRef.hide();
  }


  abort() {
    this.subject$.complete();
    this.modalRef.hide();
  }

//   /**
//  * Return true if @language is Austriac or Swiss
//  * @param language
//  * @returns
//  */
//   private isHidden(language: string) {
//     return language == 'au' || language == 'ch'
//   }

  /**
  *  Maps values from 'de' input value to 'au' and 'ch'
  * @param languageEntries
  */
  private setGermanicLanguages(languageEntries: [string, Entry][]) {
    const germanEntry = languageEntries.find(e => e[0] === 'de');
    if (germanEntry) {
      const germanValue = germanEntry[1].currentValue
      // const austriac = languageEntries.find(e => e[0] === 'au');
      // const swiss = languageEntries.find(e => e[0] === 'ch');
      // if (austriac)
      //   austriac[1].currentValue = germanValue;
      // if (swiss)
      //   swiss[1].currentValue = germanValue;
    }
  }
}

export interface ChangedTranslationValue {
  language: string,
  value: string
}

export class Entry {
  public currentValue: string
  public originalValue: string;
  constructor(public readonly value: string) {
    this.currentValue = value;
    this.originalValue = value;
  }
  changed = () => this.originalValue != this.currentValue
  deleted = () => (this.originalValue != '') && (this.currentValue == '');
}
